(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["empire-ski-pass-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ski-pass]');
    roots.forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const region = root.querySelector('[data-pass-region]');
      const skiArea = root.querySelector('[data-pass-ski-area]');
      const days = root.querySelector('[data-pass-days]');
      const adults = root.querySelector('[data-pass-adults]');
      const youths = root.querySelector('[data-pass-youths]');
      const children = root.querySelector('[data-pass-children]');
      const householdSummary = root.querySelector('[data-pass-household-summary]');
      const householdDetails = root.querySelector('.ski-pass__household details');
      const sort = root.querySelector('[data-pass-sort]');
      const grid = root.querySelector('[data-pass-grid]');
      const result = root.querySelector('[data-pass-result]');
      const empty = root.querySelector('[data-pass-empty]');
      const cards = [...root.querySelectorAll('[data-pass-card]')];
      cards.forEach((card) => {
        const note = card.querySelector('.ski-pass__note');
        if (!note) return;
        const lines = note.textContent.split(/\r?\n/).map((line) => line.trim());
        note.textContent = '';
        let list = null;
        lines.forEach((line) => {
          if (!line) {
            list = null;
            return;
          }
          if (line.startsWith('• ')) {
            if (!list) {
              list = document.createElement('ul');
              note.append(list);
            }
            const item = document.createElement('li');
            const itemText = line.slice(2);
            const separatorIndex = itemText.indexOf(':');
            const valueText = separatorIndex > -1 ? itemText.slice(separatorIndex + 1).trim() : '';
            const isPriceValue = /^[+−–—-]?\s*(CHF|EUR)\b/i.test(valueText);
            if (separatorIndex > -1 && isPriceValue) {
              list.classList.add('ski-pass__note-list--values');
              const label = document.createElement('span');
              const value = document.createElement('span');
              label.textContent = itemText.slice(0, separatorIndex);
              value.className = 'ski-pass__note-value';
              value.textContent = valueText;
              item.append(label, value);
            } else {
              item.textContent = itemText;
            }
            list.append(item);
            return;
          }
          list = null;
          const heading = document.createElement('p');
          heading.className = 'ski-pass__note-heading';
          heading.textContent = line;
          note.append(heading);
        });
      });
      const normalize = (value) => value.toLocaleLowerCase('de-CH').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      const allSkiAreasLabel = skiArea.options[0].textContent;
      const regionalSkiAreas = {
        bern: ['Adelboden-Lenk', 'Axalp', 'Grindelwald-First', 'Grindelwald-Wengen', 'Gstaad', 'Jaunpass', 'Jungfrau Ski Region', 'Meiringen-Hasliberg', 'Mürren-Schilthorn', 'Niederhorn'],
        central: ['Andermatt', 'Andermatt-Sedrun-Disentis', 'Brunni Engelberg', 'Engelberg-TITLIS', 'Gemsstock', 'Klewenalp-Stockhütte', 'Marbachegg', 'Melchsee-Frutt', 'Mörlialp', 'Mythenregion', 'Nätschen', 'Neusell', 'Oberalp', 'Rigi', 'Sattel-Hochstuckli', 'SkiArena Andermatt-Sedrun', 'Sörenberg', 'Stoos'],
        graubunden: ['Andermatt-Sedrun-Disentis', 'Arosa Lenzerheide', 'Brigels', 'Corvatsch', 'Corviglia', 'Davos Klosters', 'Diavolezza', 'Disentis', 'Grüsch-Danusa', 'Ischgl-Samnaun', 'LAAX', 'Lagalb', 'Obersaxen Mundaun', 'Pontresina', 'Samnaun', 'Savognin', 'Scuol Motta Naluns', 'Sedrun', 'Silvretta Arena Ischgl-Samnaun', 'Splügen', 'St. Moritz', 'Tschiertschen', 'Zuoz'],
        valais: ['4 Vallées', 'Aletsch Arena', 'Aminona', 'Blatten-Belalp', 'Champéry', 'Champoussin', 'Crans-Montana', 'Grimentz-Zinal', 'Les Crosets', 'Leukerbad', 'Morgins', 'Nendaz', 'Ovronnaz', 'Plaine Morte', 'Portes du Soleil', 'Saas-Almagell', 'Saas-Fee', 'St-Luc', 'Thyon', 'Torgon', 'Verbier', 'Vercorin', 'Veysonnaz', 'Zermatt']
      };
      Object.keys(regionalSkiAreas).forEach((key) => {
        regionalSkiAreas[key] = new Set(regionalSkiAreas[key].map(normalize));
      });
      const matchesSelectedRegion = (card) => region.value === 'all' || card.dataset.region.split(',').map((value) => value.trim()).includes(region.value);
      const refreshSkiAreas = () => {
        const selectedArea = skiArea.value;
        const skiAreas = new Map();
        const allowedAreas = regionalSkiAreas[region.value];
        cards.forEach((card) => {
          card.dataset.skiAreas.split(',').map((value) => value.trim()).filter(Boolean).forEach((value) => {
            const normalizedValue = normalize(value);
            if (!allowedAreas || allowedAreas.has(normalizedValue)) skiAreas.set(normalizedValue, value);
          });
        });
        skiArea.replaceChildren();
        const allOption = document.createElement('option');
        allOption.value = '';
        allOption.textContent = allSkiAreasLabel;
        skiArea.appendChild(allOption);
        [...skiAreas.entries()].sort((a, b) => a[1].localeCompare(b[1], 'de')).forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          skiArea.appendChild(option);
        });
        skiArea.value = skiAreas.has(selectedArea) ? selectedArea : '';
      };
      const update = () => {
        const skiDays = Math.max(1, Number(days.value) || 1);
        const adultCount = Math.max(0, Number(adults.value) || 0);
        const youthCount = Math.max(0, Number(youths.value) || 0);
        const childCount = Math.max(0, Number(children.value) || 0);
        const skiAreaQuery = normalize(skiArea.value);
        let shown = 0;
        cards.forEach((card) => {
          const matchesRegion = matchesSelectedRegion(card);
          const matchesSkiArea = !skiAreaQuery || normalize(card.dataset.skiAreas).includes(skiAreaQuery);
          const matches = matchesRegion && matchesSkiArea;
          card.hidden = !matches;
          const accessNote = card.querySelector('[data-pass-access-note]');
          if (accessNote) {
            const limitedAreas = card.dataset.limitedSkiAreas.split(',').map((value) => normalize(value));
            const hasLimitedAccess = limitedAreas.includes(skiAreaQuery);
            accessNote.hidden = !skiAreaQuery;
            accessNote.textContent = hasLimitedAccess ? card.dataset.limitedAccessNote : root.dataset.fullAccessNote;
            accessNote.classList.toggle('ski-pass__access-note--limited', hasLimitedAccess);
          }
          if (matches) shown += 1;
          const adultPrice = Number(card.dataset.adultPrice);
          const youthPrice = Number(card.dataset.youthPrice);
          const standardChildPrice = Number(card.dataset.childPrice);
          const familyChildPrice = Number(card.dataset.familyChildPrice);
          const childPrice = adultCount > 0 && familyChildPrice > 0 ? familyChildPrice : standardChildPrice;
          const unavailable = (adultCount > 0 && adultPrice <= 0) || (youthCount > 0 && youthPrice <= 0) || (childCount > 0 && childPrice <= 0);
          const price = unavailable ? 0 : adultCount * adultPrice + youthCount * youthPrice + childCount * childPrice;
          card.dataset.activePrice = price > 0 ? price : 999999;
          card.dataset.dailyPrice = price > 0 ? price / skiDays : 999999;
          const daily = card.querySelector('[data-pass-daily]');
          if (daily) daily.textContent = price > 0 ? (price / skiDays).toFixed(2) : '–';
        });
        const householdParts = [];
        if (adultCount) householdParts.push(`${adultCount} Erw.`);
        if (youthCount) householdParts.push(`${youthCount} Jug.`);
        if (childCount) householdParts.push(`${childCount} ${childCount === 1 ? 'Kind' : 'Kinder'}`);
        const fullHouseholdSummary = householdParts.length ? householdParts.join(' · ') : 'Keine Personen';
        const compactHouseholdParts = [];
        if (adultCount) compactHouseholdParts.push(`${adultCount} E`);
        if (youthCount) compactHouseholdParts.push(`${youthCount} J`);
        if (childCount) compactHouseholdParts.push(`${childCount} K`);
        householdSummary.textContent = householdParts.length > 2 ? compactHouseholdParts.join(' · ') : fullHouseholdSummary;
        householdSummary.title = fullHouseholdSummary;
        householdSummary.setAttribute('aria-label', fullHouseholdSummary);
        const sorted = [...cards].sort((a, b) => {
          if (sort.value === 'price') return (Number(a.dataset.activePrice) || 999999) - (Number(b.dataset.activePrice) || 999999);
          if (sort.value === 'daily') return Number(a.dataset.dailyPrice) - Number(b.dataset.dailyPrice);
          if (sort.value === 'resorts') return Number(b.dataset.resorts) - Number(a.dataset.resorts);
          return a.dataset.name.localeCompare(b.dataset.name, 'de');
        });
        sorted.forEach((card) => grid.appendChild(card));
        result.textContent = `${shown} ${shown === 1 ? 'Abo' : 'Abos'} gefunden`;
        empty.hidden = shown !== 0;
      };
      region.addEventListener('change', () => {
        refreshSkiAreas();
        update();
      });
      [skiArea, days, adults, youths, children, sort].forEach((control) => control.addEventListener('change', update));
      [days, adults, youths, children].forEach((control) => control.addEventListener('input', update));
      document.addEventListener('click', (event) => {
        if (householdDetails.open && !householdDetails.contains(event.target)) householdDetails.removeAttribute('open');
      });
      refreshSkiAreas();
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eots-market-account"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.market-account').forEach(async (account) => {
    const list = account.querySelector('[data-market-account-list]');
    const empty = account.querySelector('[data-market-account-empty]');
    const template = account.querySelector('[data-market-account-card]');
    const dialog = account.querySelector('[data-market-edit-dialog]');
    const editForm = account.querySelector('[data-market-edit-form]');
    const filters = Array.from(account.querySelectorAll('[data-status]'));
    const configureCategoryFields = () => {
      if (!editForm) return;
      const isTicket = editForm.elements.category?.value === 'Konzert-Tickets';
      const conditionField = editForm.querySelector('[data-market-condition]');
      const conditionInput = editForm.elements.condition;
      if (conditionField) conditionField.hidden = isTicket;
      if (conditionInput) {
        conditionInput.required = !isTicket;
        if (isTicket) conditionInput.value = 'Nicht zutreffend';
        else if (conditionInput.value === 'Nicht zutreffend') conditionInput.value = '';
      }
      const fields = [
        ['[data-market-brand] span', 'Marke', 'Wer spielt?'],
        ['[data-market-size] span', 'Größe', 'Wann?'],
        ['[data-market-region] span', 'Region', 'Wo?']
      ];
      fields.forEach(([selector, standardLabel, ticketLabel]) => { const node = editForm.querySelector(selector); if (node) node.textContent = isTicket ? ticketLabel : standardLabel; });
      const sizeInput = editForm.elements.size;
      if (sizeInput) sizeInput.type = isTicket ? 'datetime-local' : 'text';
    };
    editForm?.elements.category?.addEventListener('change', configureCategoryFields);
    if (!list || !empty || !template) return;
    const labels = {review: account.dataset.labelReview, active: account.dataset.labelActive, paused: account.dataset.labelPaused, sold: account.dataset.labelSold, expired: account.dataset.labelExpired};
    let listings = [];
    let messages = [];
    let selectedStatus = 'all';
    const requestAction = async (formData) => {
      const response = await fetch('/apps/empire-market/listing', {method: 'POST', body: formData, headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('action_failed');
      return response.json();
    };
    const updateCounts = () => ['all', 'review', 'active', 'paused', 'sold', 'expired'].forEach((status) => {
      const count = status === 'all' ? listings.length : listings.filter((listing) => listing.status === status).length;
      const node = account.querySelector(`[data-count="${status}"]`); if (node) node.textContent = count;
    });
    const render = (status = 'all') => {
      selectedStatus = status;
      list.replaceChildren();
      const visible = status === 'all' ? listings : listings.filter((listing) => listing.status === status);
      visible.forEach((listing) => {
        const card = template.content.firstElementChild.cloneNode(true);
        card.dataset.status = listing.status;
        const media = card.querySelector('.market-account__media');
        if (listing.imageUrl) {
          const image = document.createElement('img'); image.src = listing.imageUrl; image.alt = listing.imageAlt || listing.title; image.loading = 'lazy'; media.append(image);
        }
        card.querySelector('.market-account__status').textContent = labels[listing.status] || labels.review;
        card.querySelector('h2').textContent = listing.title;
        card.querySelector('.market-account__category').textContent = listing.category;
        card.querySelector('.market-account__price').textContent = listing.price ? `CHF ${listing.price}` : '';
        const editButton = card.querySelector('[data-action="edit"]');
        const pauseButton = card.querySelector('[data-action="pause"]');
        const deleteButton = card.querySelector('[data-action="delete"]');
        const listingMessages = messages.filter((message) => message.listingId === listing.id);
        if (listingMessages.length) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = `Nachrichten (${listingMessages.length})`;
          details.append(summary);
          listingMessages.forEach((message) => {
            const item = document.createElement('div'); item.className = 'market-account__message';
            const sender = document.createElement('strong'); sender.textContent = `${message.buyerName} · ${new Date(message.createdAt).toLocaleString('de-CH')}`;
            const body = document.createElement('p'); body.textContent = message.body;
            const reply = document.createElement('a'); reply.href = `mailto:${encodeURIComponent(message.buyerEmail)}?subject=${encodeURIComponent(`Antwort zu ${listing.title}`)}`; reply.textContent = 'Per E-Mail antworten';
            item.append(sender, body, reply); details.append(item);
          });
          card.querySelector('.market-account__messages').append(details);
        }
        pauseButton.textContent = listing.status === 'paused' ? 'Fortsetzen' : 'Pausieren';
        editButton.addEventListener('click', () => {
          ['id', 'title', 'price', 'condition', 'category', 'brand', 'size', 'region', 'country', 'description'].forEach((name) => { editForm.elements[name].value = name === 'id' ? listing.id : (listing[name] || ''); });
          configureCategoryFields();
          editForm.querySelector('[data-form-error]').hidden = true;
          dialog.showModal();
        });
        pauseButton.addEventListener('click', async () => {
          pauseButton.disabled = true;
          const data = new FormData(); data.set('id', listing.id); data.set('action', listing.status === 'paused' ? 'resume' : 'pause');
          try { const result = await requestAction(data); listing.status = result.status; updateCounts(); render(selectedStatus); } catch { alert('Die Aktion konnte nicht ausgeführt werden. Bitte erneut versuchen.'); pauseButton.disabled = false; }
        });
        deleteButton.addEventListener('click', async () => {
          if (!confirm('Dieses Inserat wirklich dauerhaft löschen?')) return;
          deleteButton.disabled = true;
          const data = new FormData(); data.set('id', listing.id); data.set('action', 'delete');
          try { await requestAction(data); listings = listings.filter((item) => item.id !== listing.id); updateCounts(); render(selectedStatus); } catch { alert('Das Inserat konnte nicht gelöscht werden. Bitte erneut versuchen.'); deleteButton.disabled = false; }
        });
        list.append(card);
      });
      empty.hidden = visible.length > 0;
    };
    try {
      const response = await fetch('/apps/empire-market/listings', {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('load_failed');
      listings = (await response.json()).listings || [];
      try {
        const messageResponse = await fetch('/apps/empire-market/messages', {headers: {'Accept': 'application/json'}});
        if (!messageResponse.ok) throw new Error('messages_load_failed');
        messages = (await messageResponse.json()).messages || [];
      } catch { account.querySelector('[data-market-messages-error]').hidden = false; }
      updateCounts();
      render();
    } catch {
      list.textContent = account.dataset.loadError;
    }
    filters.forEach((button) => button.addEventListener('click', () => {
      filters.forEach((item) => item.classList.toggle('is-active', item === button)); render(button.dataset.status);
    }));
    account.querySelectorAll('[data-dialog-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    editForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = editForm.querySelector('[type="submit"]'); const error = editForm.querySelector('[data-form-error]'); submit.disabled = true; error.hidden = true;
      try {
        const data = new FormData(editForm); await requestAction(data);
        const listing = listings.find((item) => item.id === data.get('id'));
        if (listing) ['title', 'price', 'condition', 'category', 'brand', 'size', 'region', 'country', 'description'].forEach((name) => { listing[name] = data.get(name); });
        if (listing) listing.status = 'review';
        updateCounts(); dialog.close(); render(selectedStatus);
      } catch { error.textContent = 'Die Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.'; error.hidden = false; }
      finally { submit.disabled = false; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eots-market-listing"]) return;
  try {
    
  document.querySelectorAll('[data-market-message-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const result = form.querySelector('[data-market-message-result]');
      button.disabled = true;
      result.textContent = '';
      try {
        const response = await fetch(form.action, {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'send_failed');
        form.reset();
        result.textContent = payload.notificationSent ? 'Deine Nachricht wurde übermittelt. Der Verkäufer wurde per E-Mail benachrichtigt.' : 'Deine Nachricht wurde übermittelt. Die E-Mail-Benachrichtigung konnte nicht bestätigt werden.';
      } catch {
        result.textContent = 'Die Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.';
      } finally {
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eots-market"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.eots-market').forEach((market) => {
    const buttons = market.querySelectorAll('[data-market-filter]');
    const cards = market.querySelectorAll('[data-market-card]');
    const empty = market.querySelector('[data-market-empty]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      let shown = 0;
      buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      cards.forEach((card) => {
        const visible = button.dataset.marketFilter === 'all' || card.dataset.category === button.dataset.marketFilter;
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-showcase')) {
    customElements.define('product-showcase', class ProductShowcase extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-showcase-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-showcase-dot]'));
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interactionPaused = false;
        this.buttonHovered = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.productButtons = Array.from(this.querySelectorAll('.product-showcase__button'));

        this.dots.forEach((dot, index) => dot.addEventListener('click', (event) => {
          if (event.detail > 0) this.interactionPaused = false;
          if (index === this.currentIndex) {
            this.stopTimer();
            this.startTimer(10000);
            return;
          }
          this.goTo(index, index < this.currentIndex ? -1 : 1, 10000);
        }));
        this.productButtons.forEach((button) => {
          button.addEventListener('mouseenter', () => {
            this.buttonHovered = true;
            this.stopTimer();
          });
          button.addEventListener('mouseleave', () => {
            this.buttonHovered = false;
            this.startTimer();
          });
        });
        this.addEventListener('focusin', (event) => {
          if (!event.target.matches(':focus-visible')) return;
          this.interactionPaused = true;
          this.stopTimer();
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.interactionPaused = false;
            this.startTimer();
          }
        });
        document.addEventListener('visibilitychange', () => document.hidden ? this.stopTimer() : this.startTimer());

        if (this.dataset.designMode === 'true') {
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target);
            if (index >= 0) this.goTo(index, index < this.currentIndex ? -1 : 1);
          });
        }

        this.startTimer();
      }

      goTo(requestedIndex, direction = 1, nextDelay = this.interval) {
        if (this.slides.length < 2 || requestedIndex === this.currentIndex) return;
        const nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
        const currentSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[nextIndex];
        const reverse = direction < 0;

        this.stopTimer();
        currentSlide.classList.add('is-leaving');
        if (reverse) {
          currentSlide.classList.add('is-leaving-right');
          nextSlide.classList.add('is-from-left');
        }

        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.removeAttribute('tabindex'));
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            currentSlide.classList.remove('is-active');
            nextSlide.classList.add('is-active');
            nextSlide.classList.remove('is-from-left');
          });
        });

        window.setTimeout(() => {
          currentSlide.classList.remove('is-leaving', 'is-leaving-right');
          currentSlide.setAttribute('aria-hidden', 'true');
          currentSlide.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
        }, this.reducedMotion ? 0 : 650);

        this.currentIndex = nextIndex;
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === nextIndex);
          dot.setAttribute('aria-current', index === nextIndex ? 'true' : 'false');
        });

        this.startTimer(nextDelay);
      }

      startTimer(delay = this.interval) {
        if (!this.autoplay || this.interactionPaused || this.buttonHovered || this.reducedMotion || document.hidden || this.slides.length < 2) return;
        this.stopTimer();
        this.timer = window.setTimeout(() => this.goTo(this.currentIndex + 1, 1), delay);
      }

      stopTimer() {
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
